import { Component, OnInit } from '@angular/core';
import { JavaService } from 'src/app/java.service';

@Component({
    selector: 'app-pin-incorrect',
    templateUrl: './pin-incorrect.component.html',
    styleUrls: ['./pin-incorrect.component.css']
})
export class PinIncorrectComponent implements OnInit {

    constructor(
        private _java: JavaService,
    ) { }

    ngOnInit(): void {
    }

    onBack() {
        this._java.javaConnector.goBack();
    }
}
